import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const repairOrderStatusesAdapter = getAdapter({ idFieldName: 'value' });

const repairOrderStatusesSlice = createSlice({
  name: 'repairOrderStatuses',
  initialState: repairOrderStatusesAdapter.getInitialState(),
  reducers: {
    setRepairOrderStatuses: (state, { payload: { repairOrderStatuses } }) => {
      repairOrderStatusesAdapter.setAll(state, repairOrderStatuses);
    },
  },
});

const selectors = repairOrderStatusesAdapter.getSelectors(({ repairOrderStatuses }) => repairOrderStatuses);

export const getRepairOrderStatuses = (state) => selectors.selectAll(state);

export const { setRepairOrderStatuses } = repairOrderStatusesSlice.actions;

export default repairOrderStatusesSlice.reducer;
